import _isEqual from 'lodash/isEqual'

const targetGroupMaker = ({ initialTargetGroup, currentTargetGroup }) => {
  const isUpdated = !_isEqual(initialTargetGroup, currentTargetGroup)
  return {
    id: currentTargetGroup.id,
    name: currentTargetGroup.name,
    locationType: currentTargetGroup.locationType,
    accessibleType: currentTargetGroup.accessibleType,
    locationCount: currentTargetGroup.locationCount,
    updated: isUpdated,
  }
}

export default targetGroupMaker
